'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomePage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HomePage() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
    _react2.default.createElement(
      'h1',
      null,
      'Homepage'
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/HomePage/index.js
// module id = 2329
// module chunks = 0